var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.show,
      "no-close-button": true
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "my-15 flex flex-col items-center space-y-10 min-h-screen"
  }, [_c('h4', {
    staticClass: "text-indigo-600"
  }, [_vm._v("Filtres " + _vm._s(_vm.tab))]), _vm._v(" "), _vm.filters.beneficiaries.length > 0 && _vm.tab === 'Bénéficiaires' ? _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('InputText', {
    attrs: {
      "libelle": "Nom du groupe",
      "placeholder": "Donnez un nom au nouveau groupe",
      "value": _vm.groupName
    },
    on: {
      "input": function (newValue) {
        return _vm.groupName = newValue;
      }
    }
  }), _vm._v(" "), _vm.groupName === undefined || _vm.groupName === '' ? _c('div', {
    staticClass: "text-sm text-red-500"
  }, [_vm._v("\n        Veuillez donner un nom au nouveau groupe\n      ")]) : _vm._e(), _vm._v(" "), _c('ActionButton', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-indigo-600",
      "icon": "plus",
      "responsive": true,
      "libelle": "Créer un nouveau groupe à partir de la sélection",
      "is-disabled": _vm.groupName === undefined || _vm.groupName === ''
    },
    on: {
      "clickAction": _vm.createGroup
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "place-self-start w-full"
  }, [_vm.tab === 'Bénéficiaires' ? _c('beneficiaries-filter', {
    attrs: {
      "filter": _vm.filters.beneficiaries,
      "groups": _vm.userGroups
    },
    on: {
      "updateBeneficiariesFilter": function (beneficiariesFilter) {
        _vm.$emit('updateBeneficiariesFilter', beneficiariesFilter);
      },
      "groupDeleted": _vm.loadGroups
    }
  }) : _vm._e(), _vm._v(" "), _vm.tab === 'Compétences' ? _c('competences-filter', {
    staticClass: "md:mx-15",
    attrs: {
      "filter": _vm.filters.competences,
      "templates": _vm.templates
    },
    on: {
      "updateCompetencesPersoFilter": function (competencesFilter) {
        _vm.$emit('updateCompetencesPersoFilter', competencesFilter);
      },
      "updateCompetencesSocioFilter": function (competencesFilter) {
        _vm.$emit('updateCompetencesSocioFilter', competencesFilter);
      },
      "updateCompetencesProFilter": function (competencesFilter) {
        _vm.$emit('updateCompetencesProFilter', competencesFilter);
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5"
  }, [_vm.tab === 'Compétences' ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": 'Précédent',
      "uppercase": true,
      "icon": "arrow-circle-left",
      "type-shadow": "shadow-pink",
      "right": false
    },
    on: {
      "clickAction": _vm.previousStep
    }
  }) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": _vm.tab === 'Bénéficiaires' ? 'Suivant' : 'Valider',
      "uppercase": true,
      "icon": _vm.tab === 'Bénéficiaires' ? 'arrow-circle-right' : 'checkmark-circle-2',
      "type-shadow": "shadow-pink",
      "right": true
    },
    on: {
      "clickAction": _vm.nextStep
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }